<div class="fulfillmentLanding">
  <div class="status-bar">
    New rates will be updated to actual cost through overnight refresh.
  </div>
</div>
<div class="fulfillmentLanding seed-return-wrapper priceStimulationHeader">
  <div class="cppReturnsLandingPage">
    <div class="row">
      <div class="col-8 margin-l0 TopSec m-auto">
        <h3>
          Price Simulation
        </h3>
      </div>
      <div class="col-4 text-right m-auto">
        <span class="close-btn text-uppercase" (click)="closePage()"> Close <i class="fas fa-times"></i></span>
      </div>
    </div>

    <div class="form-sec padding-10">
      <div class="row gx-3 margin-t10 padding-l15 padding-r15">
        <div class="col-6">
          <p><a class="link" (click)="tileSelection(true)">SELECT ALL</a></p>
        </div>
        <div class="col-6 text-right padding-r25">
          <p><a class="link" (click)="saveTempRates(true, false)">DESELECT ALL</a></p>
        </div>

        <div class="col-12 padding-r0">
          <ng-template ngFor let-item [ngForOf]="tilesList" let-i="index">
            <div class="priceStimulationData row" [ngClass]="item.selected ? 'active' : ''">
              <p class="priceText col-12">{{item.text}}</p>
              <div class="col-12">
                <div class="checkboxCircle">
                  <mat-checkbox class="custom-checkbox select-all-check"
                                [(ngModel)]="item.selected"
                                (ngModelChange)="checkSimulationDisableChange()">
                  </mat-checkbox>
                </div>
              </div>
              <div class="col-12 updateBg sraPriceInput">
                <div class="row">
                  <div class="col-7 pr-0">
                    <p>NEW RATE</p>
                  </div>
                  <div class="col-5">
                    <mat-form-field class="w-100">
                      <input matInput [(ngModel)]="item.rateValue" (keypress)="keyPressNumeric($event)" (ngModelChange)="checkSimulationDisableChange()">
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="row margin-t10">
      <div class="col-4 count m-auto">
        SELECTED <span>{{selectedItemCount}}</span>
      </div>
      <div class="col-8 text-right">
        <button mat-raised-button class="btns margin-r10 w140 height-36" [disabled]="isSimulationDisable || isRunSimulationDisable" (click)="GetGridData()">Run Simulation</button>
        <button mat-raised-button class="btns margin-r10 w140 height-36" [disabled]="isResetAllDisable" (click)="saveTempRates(true, false)">Reset All</button>
        <button mat-raised-button class="btns margin-r10 w140 height-36" [disabled]="isAcceptRateDisable" (click)="saveTempRates(false, false)">Accept Rates</button>
        <button mat-raised-button class="btns margin-r10 w140 height-36" (click)="exportExcel()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer margin-t10 sraTablePriceSimulation">

        <div class="fulfill-top-sec">
          <div class="row listing-action-items">

            <div class="col-md-4">
            </div>

            <div class="col-md-8 text-right">
              <ul>
                <li class="" matTooltip="Save Toggle Preference" (click)="saveToggleColumnSettings()" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                  <i class="fas fa-save"></i>
                </li>
              </ul>
              <div class="display-ib wAuto">
                <mat-paginator #costSheetSimulationPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
              </div>
            </div>
          </div>
        </div>

        <div class="tableContainer activeReturnRequest">
          <table mat-table #coiTable [dataSource]="costSheetDataSimulationSource" matSort #coiSort matSortDirection="desc" class="matTables coiActiveTable">
            <ng-container matColumnDef="customerNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Customer Number
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[0][iRow].span"
                  [style.display]="rowSpans[0][iRow].span === 0 ? 'none' : ''" class="ml-0">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.customerNumber}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="customerName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Customer Name
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[1][iRow].span"
                  [style.display]="rowSpans[1][iRow].span === 0 ? 'none' : ''" class="text-left">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.customerName}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="itemDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column accName text-center">
                Item Description
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[2][iRow].span"
                  [style.display]="rowSpans[2][iRow].span === 0 ? 'none' : ''" class="text-center" style="border-spacing:10px">

                {{row.itemDescription}}
              </td>
            </ng-container>
            <ng-container matColumnDef="winfieldProduct">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                WinField United Product #
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" [attr.rowspan]="rowSpans[3][iRow].span"
                  [style.display]="rowSpans[3][iRow].span === 0 ? 'none' : ''" class="text-center">
                <div class="order-info cursor-default-pointer text-center">
                  <p class="grower-name">
                    {{row.winfieldProduct}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="supplier">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Supplier
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.supplier}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="productLine">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Product Line
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.productLine}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="productGroup">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Product Group
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.productGroup}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="vendedHIF">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Vended HIF
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.vendedHIF}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="palletQuantity">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Pallet Quantity
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.palletQuantity}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="packageSize">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Package Size
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.packageSize}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="pricingUnit">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Pricing Unit
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.pricingUnit}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="rup">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                RUP
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.rup}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="nonReturnable">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Non-Returnable
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.nonReturnable}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="priceChangeIndicator">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Price Change Indicator
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.priceChangeIndicator}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="priceEffectiveDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Price Effective Date
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.priceEffectiveDate | date: masterConstants.DATE_MMDDYYYY}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="termEffectiveDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Term Effective Date
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.termEffectiveDate | date: masterConstants.DATE_MMDDYYYY}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="nationalPrice">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('nationalPrice')" [ngClass]=" coloumnToAddHeaderCss['nationalPrice'] ? 'changeTextColor' : '' ">
                National Price
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.nationalPriceChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.nationalPrice)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="distributorList">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('distributorList')" [matTooltip]="getToolTipValue('distributorList')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['distributorList'] ? 'changeTextColor' : '' ">
                Distributor List
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.distributorListChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="(row.vendedHIFAtCost == true && row.vendedHIF == 'Y')" class="grower-name">
                    {{amountValue(row.distributorList)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="redemptionPrice">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Redemption Price
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.redemptionPrice)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="redemptionPriceMethodology">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Redemption Price Methodology
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.redemptionPriceMethodology}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="competitiveAllowancePc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('competitiveAllowancePc')" [ngClass]=" coloumnToAddHeaderCss['competitiveAllowancePc'] ? 'changeTextColor' : '' ">
                Competitive Allowance %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.competitiveAllowancePCChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.competitiveAllowancePc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="specialPricePc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('competitiveAllowancePc')" [ngClass]=" coloumnToAddHeaderCss['specialPricePc'] ? 'changeTextColor' : '' ">
                Special Price %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.specialPricePCChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.specialPricePc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="invoicePrice">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Invoice Price
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.invoicePriceChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.invoicePrice)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="manufacturerSurchargePc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Manufacturer Surcharge %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.manufacturerSurchargePCChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.manufacturerSurchargePc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="manufacturerSurcharge">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" [ngClass]=" coloumnToAddHeaderCss['manufacturerSurcharge'] ? 'changeTextColor' : '' ">
                <mat-checkbox class="custom-checkbox"
                              [style.display]="'contents'"
                              [checked]="columnSelection.manufacturerSurcharge"
                              (change)="columnCheckboxSelection('manufacturerSurcharge',$event)"> </mat-checkbox>
                Manufacturer Surcharge $
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.manufacturerSurchargeChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.manufacturerSurcharge)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="invoicePricewithSurcharge">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Invoice Price with Surcharge
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.invoicePricewithSurchargeChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.invoicePricewithSurcharge)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="wholesaleRebatePcguidance">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('wholesaleRebatePcguidance')"
                  [matTooltip]="getToolTipValue('wholesaleRebatePcguidance')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['wholesaleRebatePcguidance'] ? 'changeTextColor' : '' ">
                Wholesale Rebate % (Guidance)
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.wholesaleRebatePCGuidanceChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="(row.vendedHIFAtCost == true && row.vendedHIF == 'Y')" class="grower-name">
                    {{percentValue(row.wholesaleRebatePcguidance)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="distributionCost">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('distributionCost')" [matTooltip]="getToolTipValue('distributionCost')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['distributionCost'] ? 'changeTextColor' : '' ">
                <mat-checkbox class="custom-checkbox"
                              [style.display]="'contents'"
                              [checked]="columnSelection.distributionCost"
                              (change)="columnCheckboxSelection('distributionCost',$event)"></mat-checkbox>
                Distribution Cost $
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.distributionCost)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="wuDeliveredCost">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" [matTooltip]="getToolTipValue('wuDeliveredCost')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp">
                WU Delivered Cost
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.wuDeliveredCost)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="wuDeliveredCostPcOffNationalwoMfgSurcharge">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost % Off National</th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.wuDeliveredCostPcOffNationalwoMfgSurcharge)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="wuDeliveredCostPcOffNationalwMfgSurcharge">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost % Off National w/ Mfg Surcharge</th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.wuDeliveredCostPcOffNationalwMfgSurcharge)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="contractPrepayPc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('contractPrepayPc')" [matTooltip]="getToolTipValue('contractPrepayPc')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['contractPrepayPc'] ? 'changeTextColor' : '' ">
                Contract Prepay %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.prepayPCChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.contractPrepayPc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="wuDeliveredCostwPrepay">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost w/ Prepay</th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.wuDeliveredCostwPrepay)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="wuDeliveredCostwPrepayPCoffNational">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">WU Delivered Cost w/ Prepay % off National</th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.wuDeliveredCostwPrepayPCoffNational)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="srarebatePcguidance">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center" (mouseenter)="findColumninvolment('srarebatePcguidance')"
                  [matTooltip]="getToolTipValue('sraRebatePCGuidance')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['srarebatePcguidance'] ? 'changeTextColor' : '' ">
                SRA Rebate % (Guidance)
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="blue-column text-center" [ngStyle]="row.sRARebateGuidanceChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.srarebatePcguidance)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="dividendPc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="blue-column return-request text-center">
                Dividend %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.dividendPc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailBaseRebates">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                National Mfg Published Rebate
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.retailBaseRebates)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailStockingRebate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                <mat-checkbox class="custom-checkbox"
                              [style.display]="'contents'"
                              [checked]="columnSelection.retailStockingRebate"
                              (change)="columnCheckboxSelection('retailStockingRebate',$event)"></mat-checkbox>
                Retail Stocking Rebate
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="row.retailStockingRebate > 0" class="grower-name">
                    {{percentValue(row.retailStockingRebate)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailUnpublishedRebates">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                <mat-checkbox class="custom-checkbox"
                              [style.display]="'contents'"
                              [checked]="columnSelection.retailUnpublishedRebates"
                              (change)="columnCheckboxSelection('retailUnpublishedRebates',$event)"></mat-checkbox>
                Retail Unpub Rebate
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="row.retailUnpublishedRebates > 0" class="grower-name">
                    {{percentValue(row.retailUnpublishedRebates)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailLocalRebate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                <mat-checkbox class="custom-checkbox"
                              [style.display]="'contents'"
                              [checked]="columnSelection.retailLocalRebate"
                              (change)="columnCheckboxSelection('retailLocalRebate',$event)"></mat-checkbox>
                Retail Local Rebate
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="row.retailLocalRebate > 0" class="grower-name">
                    {{percentValue(row.retailLocalRebate)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="lowNetwoPrepay">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [ngClass]=" coloumnToAddHeaderCss['lowNetwoPrepay'] ? 'changeTextColor' : '' ">
                Low Net w/o Prepay
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.lowNetwoPrepayChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.lowNetwoPrepay)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="totDiscountOffNatlwoPrepay">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                Tot Discount Off Natl w/o Prepay
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.totDiscountOffNatlwoPrepay)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="prepayEligible">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('prepayEligible')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp">
                Prepay Eligible
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.prepayEligible}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="nationalPaymentTerms">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                National Payment Terms
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{row.nationalPaymentTerms}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="currentAprpc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('currentAprpc')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp">
                Current APR %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.currentAprpc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="decAprpc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('decAprpc')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp">
                Dec APR %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.decAprpc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="juneAprpc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('juneAprpc')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp">
                June APR %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.juneAprpc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="prepayPc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" [matTooltip]="getToolTipValue('prepayPc')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp">
                Prepay %
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="row.prepayPc > 0" class="grower-name">
                    {{percentValue(row.prepayPc)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="lowNetwPrepay">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center" (mouseenter)="findColumninvolment('lowNetwPrepay')" [matTooltip]="getToolTipValue('lowNetwPrepay')" matTooltipPosition="above"
                  matTooltipClass="whiteFontCpp" [ngClass]=" coloumnToAddHeaderCss['lowNetwPrepay'] ? 'changeTextColor' : '' ">
                Low Net w/ Prepay
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center" [ngStyle]="row.lowNetwPrepayChangeFlag ? {'background': '#FDCF35'}:'' ">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.lowNetwPrepay)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="pcoffNationalwPrepay">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                % Off National w/ Prepay
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{percentValue(row.pcoffNationalwPrepay)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailMarginT1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                Retail Margin - Tier 1
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="row.retailMarginT1 > 0" class="grower-name">
                    {{percentValue(row.retailMarginT1)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailMarginT2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                Retail Margin - Tier 2
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="row.retailMarginT2 > 0" class="grower-name">
                    {{percentValue(row.retailMarginT2)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailMarginT3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                Retail Margin - Tier 3
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p *ngIf="row.retailMarginT3 > 0" class="grower-name">
                    {{percentValue(row.retailMarginT3)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailMarginT1Price">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                Retail Price - Tier 1
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.retailMarginT1Price)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailMarginT2Price">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                Retail Price - Tier 2
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.retailMarginT2Price)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="retailMarginT3Price">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">
                Retail Price - Tier 3
              </th>
              <td mat-cell *matCellDef="let row; let iRow = index" class="text-center">
                <div class="order-info cursor-default-pointer">
                  <p class="grower-name">
                    {{amountValue(row.retailMarginT3Price)}}
                  </p>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnNames;sticky:true;"></tr>
            <tr mat-row *matRowDef="let row; columns: columnNames;" [ngClass]="row.isRowHighlighted ? 'highlightRow':'' "></tr>
          </table>
          <div *ngIf="!costSheetDataSimulationList || costSheetDataSimulationList.length == 0" class="noDataMsg">
            <p class="padding-b47">No Record Found.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
